import { fork, put, takeEvery, all, delay } from 'redux-saga/effects';
import config from '../../../config/config';
import PerplayGameApi from '../../models/src/api/PerplayGameApi';
import {
  CREATE_GAME_CONFIG,
  GAME_CONFIG_INFO_LIST_REQUEST,
  REMOVE_GAME_CONFIG,
  UPDATE_GAME_CONFIG,
} from '../../constants/app/fixAppDataConstants';
import {
  GameControllerDtoGameConfigCreateRequest,
  GameControllerDtoGameConfigRemoveRequest,
  GameControllerDtoGameConfigUpdateRequest,
} from '../../models/src';
import BaseResponse from '../../models/src/model/BaseResponse';
import GameControllerDtoGameConfigInfoResponse from '../../models/src/model/GameControllerDtoGameConfigInfoResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayGameApi(config.API_CLIENT);

function* gameConfigInfoListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiPerplayGameGameConfigInfoPost(() => {});
    const data = api.apiClient.deserialize(result, GameControllerDtoGameConfigInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* createGameConfigSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new GameControllerDtoGameConfigCreateRequest();
    requestData.configKey = payload.configKey;
    requestData.value = payload.value;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayGameGameConfigCreatePost({gameControllerDtoGameConfigCreateRequest: requestData}, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* removeGameConfigSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new GameControllerDtoGameConfigRemoveRequest();
    requestData.configKey = payload.configKey;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayGameGameConfigRemovePost({ gameControllerDtoGameConfigRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* updateGameConfigSaga(payload) {
  try {
    const requestData = new GameControllerDtoGameConfigUpdateRequest();
    requestData.configKey = payload.configKey;
    requestData.value = payload.value;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayGameGameConfigUpdatePost({ gameControllerDtoGameConfigUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* gameConfigRootSaga() {
  yield all([
    takeEvery(GAME_CONFIG_INFO_LIST_REQUEST, gameConfigInfoListRequestSaga),
    takeEvery(CREATE_GAME_CONFIG, createGameConfigSaga),
    takeEvery(REMOVE_GAME_CONFIG, removeGameConfigSaga),
    takeEvery(UPDATE_GAME_CONFIG, updateGameConfigSaga),
  ]);
}

const fixAppDataSagas = [fork(gameConfigRootSaga)];

export default fixAppDataSagas;
